import React from "react";
import { Modal } from "antd";
import styles from "./index.module.scss";
import { useModalStore } from "@/store/modle";
import close from "@/assets/images/close.svg";
import { useDataStore } from "@/store/dataStore";
import { getChainInfoById } from "@/constants/const";
import { targetChainId } from "./StakeModal";

export default function WithdrawSuccessModal({ txHash }: { txHash: string }) {
  const { isMobile } = useDataStore((state) => state);
  const setShowWithdrawSuccessModal = useModalStore(
    (state) => state.setShowWithdrawSuccessModal
  );
  const showWithdrawSuccessModal = useModalStore(
    (state) => state.showWithdrawSuccessModal
  );
  const { setRefreshData } = useDataStore((state) => state);

  return (
    <Modal
      closable
      open={showWithdrawSuccessModal}
      width={460}
      centered
      style={{ top: "-40px" }}
      destroyOnHidden
      title={null}
      onCancel={() => {
        setRefreshData();
        setShowWithdrawSuccessModal(false);
      }}
      footer={null}
      maskClosable={false}
      className={`${styles.commonModal} ${styles.statusModal}`}
      closeIcon={<img src={close} alt="logo" width={24} height={24} />}
    >
      <img
        src={
          "https://brevis-frontend.s3.us-west-1.amazonaws.com/provenet/imgs/withdrawSuccess.svg"
        }
        alt="chainSwitchWarning"
        width={280}
        className={styles.commonImg}
      />
      {isMobile ? (
        <div>
          <div className={styles.commonDes}>You have successfully</div>
          <div className={styles.commonDes2}>withdrawn your stakes.</div>
        </div>
      ) : (
        <div>
          <div className={styles.commonDes}>
            You have successfully withdrawn
          </div>
          <div className={styles.commonDes2}>your stakes.</div>
        </div>
      )}
      <div
        className={styles.commonLink}
        style={{
          marginTop: 20,
          fontSize: 14,
          fontFamily: "HKNova-Medium, sans-serif",
          fontWeight: 500,
        }}
        onClick={() => {
          window.open(
            getChainInfoById(targetChainId).blockExplorerUrl + "/tx/" + txHash,
            "_blank"
          );
        }}
      >
        View in explorer
      </div>
      <div
        className={styles.commonBtn}
        style={{ marginTop: 32 }}
        onClick={() => {
          setRefreshData();
          setShowWithdrawSuccessModal(false);
        }}
      >
        Done
      </div>
    </Modal>
  );
}
